import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import LogRocket from 'logrocket';
import { init as initApm } from '@elastic/apm-rum';

import SignUp from './components/SignUp/SignUp';

import 'emerald-ui/lib/styles-ceb.css';

const { REACT_APP_ENV } = process.env;
const config = require(`./config/${REACT_APP_ENV}.config.js`);

if (REACT_APP_ENV === 'test') {
  LogRocket.init('acws4p/provider-signup-test');
}

if (REACT_APP_ENV === 'production') {
  LogRocket.init('acws4p/provider-signup');
}

// APM initialization

const ENVIRONMENTS = {
  test: 'Test',
  demo: 'Demo',
  production: 'Production',
};

if (REACT_APP_ENV && REACT_APP_ENV !== 'development') {
  initApm({
    serviceName: 'ceb-providers-sign-up-front',
    serverUrl: config.REACT_APP_APM_SERVER_URL,
    environment: ENVIRONMENTS[REACT_APP_ENV],
    serviceVersion: '1.0.0',
  });
}

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/" component={SignUp} />
    </Switch>
  </BrowserRouter>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js